import { FunctionComponent, HTMLAttributes, ReactNode } from 'react';
import { cn } from '../../utilities/cn';
import Pill, { type PillProps } from './Pill';

export interface FundNameWithDemoPillProps
  extends HTMLAttributes<HTMLDivElement> {
  children: ReactNode;
  isDemo?: boolean;
  /** Extra props forwarded to the Demo `Pill` when shown. */
  pillProps?: Omit<PillProps, 'children' | 'status'>;
}

/** Fund label with an optional Demo badge (from get_funds / is_demo_fund). */
export const FundNameWithDemoPill: FunctionComponent<
  FundNameWithDemoPillProps
> = ({ children, isDemo = false, className, pillProps, ...props }) => {
  return (
    <div
      className={cn('flex items-center gap-2', className)}
      {...props}
    >
      <span className="leading-none">{children}</span>
      {isDemo ? (
        <Pill status="demo" {...pillProps}>
          Demo
        </Pill>
      ) : null}
    </div>
  );
};

export default FundNameWithDemoPill;
